import { IEmailSignin, ISignin, ITrustedDeviceSignin, IValidateUserSignin } from 'src/interfaces';
import http from './http';

class SigninService {
  static signin(data: ISignin) {
    return http.post('/auth/signin', data);
  }

  static requestEmailCode(data: IValidateUserSignin) {
    return http.post('/auth/email-code', data);
  }

  static signinWithEmailCode(data: IEmailSignin) {
    return http.post('/auth/signin-email', data);
  }

  static signinWithTrustedDevice(data: ITrustedDeviceSignin) {
    return http.post('/auth/signin-trusted', data);
  }
}
export default SigninService;
